/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品契約詳細
 */
export interface Szma301aResFutaiproductContractdetailsDto {
    /**
     * 名称
     */
    aname?: string;
    /**
     * 数量
     */
    quantity?: string;
    /**
     * 数量単位
     */
    quantityUnit?: string;
    /**
     * 月額利用料
     */
    monthlyUsagefee?: string;
    /**
     * 月額利用料単位
     */
    monthlyUsagefeeUnit?: string;
    /**
     * 開始年月
     */
    startYm?: string;
}

